import HoneyPot from './HoneyPot'

export default HoneyPot
